// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_2iImQy","clearfix":"_2k9jNO","spinner":"_2QqWYl"};